// extracted by mini-css-extract-plugin
export default {"component":"style_component__9V+70","inner":"style_inner__fpO8T","close":"style_close__vjppg","bg_main":"style_bg_main__e8TYG","bg_top":"style_bg_top__Je28f"};